import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const CreateAndEditContestContainer = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 90px;
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`;

export const BackAndSaveButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ContestHeading = styled.h2`
  margin-bottom: 3rem !important;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin-top: 1rem;
`;

export const TopButtonContainer = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  ${(props) =>
    props.floatLeft &&
    css`
      float: left !important;
    `}
`;

export const RenderTabContainer = styled.div`
  flex: 0 0 83.333333%;
  max-width: 83.333333%;
  padding-left: 0 !important;
`;

export const ContestNameAndDurationWrapContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  justify-content: center;
`;

export const ContestNameContainer = styled.div`
  flex: 0 0 83.333333%;
  ${({ disableMargin }) =>
    !disableMargin &&
    css`
      margin-top: 1.5rem !important;
    `}

  @media (max-width: 576px) {
    flex: 0 0 100%;
  }
`;

export const ContestNameAndDurationContainer = styled.div`
  min-height: 400px;
  background: white;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label``;

export const DateContainer = styled.div`
  flex: 0 0 41.666667%;
  margin-top: 1.5rem !important;
  padding: ${(props) => (props.padding ? props.padding : `0px`)};
  @media (max-width: 576px) {
    flex: 0 0 100%;
    padding: 0px;
  }
`;

export const BrandingContainer = styled.div`
  width: 100%;
  min-height: 300px;
  padding: 1.25rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
`;

export const HorizontalLine = styled.hr`
  margin-right: 0;
  margin-left: 0;
`;

export const LeftAndRightTabContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const LeftTabContainer = styled.div`
  border-right: 1px solid rgb(222, 226, 230);
  height: 100% !important;
  padding-bottom: 3rem !important;
  padding-top: 3rem !important;
  padding-right: 0 !important;
  margin-top: 0 !important;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0px !important;
  }
`;

export const LeftTabHeading = styled.div`
  width: 100% !important;
  border: 1px solid #dee2e6;
  border-top-left-radius: 4px;
  background-color: white;
  border-bottom-left-radius: 4px;
  margin-bottom: 20px;
  border-right: 0px;
  cursor: pointer;
  color: #919396;
  float: left;
  margin-top: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 10px;
  ${(props) =>
    props.isActive &&
    css`
      color: #295c88 !important;
      font-weight: 600 !important;
      width: 101% !important;
    `}
`;

export const ContestLogoHeading = styled.h5`
  text-align: center;
`;

export const RunTournamentContainer = styled.div`
  flex: 1 1 auto;
  padding: 1.25rem;
  background: white;
`;

export const RunTournamentLabelAndCheckbox = styled.div`
  margin-left: 0.25rem !important;
  display: inline-flex;
  cursor: pointer;
`;

export const RunTournamentInputCheckbox = styled.input`
  height: 20px;
  width: 20px;
`;

export const RunTournamentLabel = styled.label`
  margin-left: 0.5rem !important;
`;

export const RunTournamentTimeContainer = styled.div``;

export const Input = styled.input``;

export const EditorLogoContainer = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
`;

export const UploadAndRemoveButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ButtonContainer = styled.div`
  margin-left: 10px;
`;

export const Button = styled.button`
  margin-left: 6px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  color: white;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  background-color: #295c88;
  display: inline-block;
  ${(props) =>
    props.floatRight &&
    css`
      float: right !important;
    `}
`;

export const InputLogo = styled.input`
  width: ${(props) => (props.isBackgroundImage ? `170px` : `115px`)};
  height: 38px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  cursor: pointer;
`;

export const InputLogoLabel = styled.label`
  margin-left: 5px;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  color: white;
  border-radius: 6px;
  background-color: #295c88;
  display: inline-block;
`;

export const ImageContainer = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`;

export const LogoImage = styled.img`
  width: 50%;
  border: 1px solid #dee2e6;
  ${(props) =>
    props.isBackgroundImage &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const SponsorTabContainer = styled.div`
  min-height: 400px;
  background: white;
`;

export const SponsorTabInnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  width: 80%;
  margin: auto;
`;

export const CompanyNameContainer = styled.div`
  flex: 0 0 50%;
  margin-top: 1.5rem !important;
  padding-right: 10px;
  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding: 0px;
  }
`;

export const SponsorDateContainer = styled.div`
  flex: 0 0 50%;
  margin-top: 1.5rem !important;
  padding-right: 10px;
  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding: 0px;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 35px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  padding-left: 10px;
  :focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  }
`;

export const Option = styled.option``;

export const OldSponsorContainer = styled.div`
  width: 80%;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 30px;
`;

export const OldSponsorHeading = styled.h3`
  color: ${colors.darkBlue};
`;
